import { render, staticRenderFns } from "./ReleaseCreate.vue?vue&type=template&id=0449033c&scoped=true&"
import script from "./ReleaseCreate.vue?vue&type=script&lang=js&"
export * from "./ReleaseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0449033c",
  null
  
)

export default component.exports